import MeetingCommentReply from './MeetingCommentReply'
import MeetingComment, {CommentAttachment, CommentReactedUser, CommentUser} from './MeetingComment'
import DeletedComment from './DeletedComment'

export default class MeetingCommentDetail extends MeetingComment {
    commentReplyList: (MeetingCommentReply | DeletedComment)[]

    constructor(
        meetingCommentId: number,
        content: string,
        user: CommentUser,
        updateDatetime: string,
        commentReactedUserList: CommentReactedUser[],
        attachmentList: CommentAttachment[],
        isYou: boolean,
        version: number,
        commentReplyList: (MeetingCommentReply | DeletedComment)[],
    ) {
        super(meetingCommentId, content, user, updateDatetime, commentReactedUserList, attachmentList, isYou, version)
        this.commentReplyList = commentReplyList
    }
}
